export default __webpack_public_path__ + "static/media/quarto5.83e1194b.jpg";